import React, { useState } from 'react'
import { MenuItem, Menu, Typography, Box } from '@mui/material'
import {
    Link,
    useMatch,
    useResolvedPath,
} from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const styles = {
    icons: {
        verticalAlign: 'text-bottom'
    }
}

function CustomLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });

    return (
        <div>
            <Link
                style={{
                    textDecoration: "none",
                    color: match ? '#F0D201' : '#FFFFFF',
                    fontFamily: 'VarelaRound',
                    fontSize: 20,
                }}
                to={to}
                {...props}
            >
                {children}
            </Link>
        </div>
    );
}

export default function EventsMenu() {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Typography
                    onClick={handleClick}
                    size="small"
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    sx={{
                        textDecoration: "none",
                        color: '#FFFFFF',
                        fontFamily: 'VarelaRound',
                        fontSize: 18,
                        cursor: 'pointer'
                    }}
                >
                    Events {open ? <ArrowDropDownIcon sx={styles.icons} /> : <ExpandMoreIcon sx={styles.icons} />}
                </Typography>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        backgroundColor: '#591934',
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 65,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'center', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            >
                <MenuItem>
                    <CustomLink to="/events/wedding" >Weddings</CustomLink>
                </MenuItem>
                <MenuItem>
                    <CustomLink to="/events/celebrate" >Celebration</CustomLink>
                </MenuItem>
                <MenuItem>
                    <CustomLink to="/events/corporate" >Corporate</CustomLink>
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
